import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

const PERIODS = ["daily", "weekly", "monthly", "yearly"];

export default function GovWasteReport() {
  const [period, setPeriod] = useState("monthly");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/gov/waste-report?period=${period}`)
      .then(r => setData(r.data))
      .catch(e => toast.error(formatApiError(e)));
  }, [period]);

  const rows = data?.rows || [];
  const totals = rows.reduce((a, r) => ({
    bags: a.bags + r.bags, kg: a.kg + r.kg, co2: a.co2 + r.co2_kg
  }), { bags: 0, kg: 0, co2: 0 });

  return (
    <div className="space-y-4" data-testid="gov-waste-report">
      <div>
        <h1 className="font-heading text-3xl">Waste Report</h1>
        <p className="text-sm text-[#5C5A55] mt-1">Tonnage + CO₂ impact · Read-only</p>
      </div>

      <div className="flex gap-2">
        {PERIODS.map(p => (
          <button key={p} data-testid={`gov-period-${p}`}
                  onClick={() => setPeriod(p)}
                  className={`px-3 h-9 rounded-md text-xs uppercase tracking-[0.18em] border ${period === p ? "bg-[#2D5A27] text-white border-[#2D5A27]" : "bg-white border-[#E5E2D9] text-[#5C5A55]"}`}>
            {p}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Kpi label="Total Bags" value={totals.bags}/>
        <Kpi label="Total Weight" value={`${totals.kg.toFixed(1)} kg`}/>
        <Kpi label="CO₂ Reduced" value={`${totals.co2.toFixed(1)} kg`}/>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3">Waste Type</th>
              <th className="px-6 py-3">Category</th>
              <th className="px-6 py-3 text-right">Bags</th>
              <th className="px-6 py-3 text-right">Weight (kg)</th>
              <th className="px-6 py-3 text-right">CO₂ (kg)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="px-6 py-12 text-center text-[#8A8780]">No data this period.</td></tr>}
            {rows.map((r, i) => (
              <tr key={r.waste_type_id || i} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"}>
                <td className="px-6 py-3 font-medium">{r.waste_name}</td>
                <td className="px-6 py-3 text-xs uppercase tracking-[0.2em] text-[#5C5A55]">{r.category || "—"}</td>
                <td className="px-6 py-3 text-right font-mono">{r.bags}</td>
                <td className="px-6 py-3 text-right font-mono">{r.kg.toFixed(1)}</td>
                <td className="px-6 py-3 text-right font-mono">{r.co2_kg.toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Kpi = ({ label, value }) => (
  <div className="bg-white border border-[#E5E2D9] rounded-md p-5">
    <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A8780]">{label}</div>
    <div className="font-heading text-3xl mt-1">{value}</div>
  </div>
);
